import 'whatwg-fetch';
import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';

import { FetchService } from './fetch-service';
import { LoggerService } from './logger-service';
import { BrowserStorageService } from './browser-storage-service';

var crypto = require('crypto-js');
var config = require('../../../config');

@inject(FetchService, LoggerService, BrowserStorageService)
export class AdvertiserService {
    constructor(fetchService, loggerService, browserStorage) {
        this.httpClient = new HttpClient();
        this.fetchService = fetchService;
        this.logger = loggerService;
        this.browserStorage = browserStorage;

        var allHeaders = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        var authorize = this.browserStorage.getItem('authorization');

        if (authorize) {
            allHeaders.headers.Authorization = window.atob(authorize);
        }

        this.httpClient.configure(httpConfig => {
            httpConfig.withBaseUrl('/').withDefaults({
                headers: allHeaders.headers
            });
        });
    }

    getAdvertiserNames() {
        var encodedString = this.browserStorage.getItem('advertiserNames');
        if (encodedString) {
            var encryptedString = decodeURIComponent(encodedString);
            var names = crypto.AES.decrypt(encryptedString, 'delty-rocks').toString(
                crypto.enc.Utf8
            );
            return names.split(',');
        }
    }

    getAdvertisers() {
        this.logger.debug('getAdvertisers() called');
        let that = this;
        let fetchUrl = config.advertiserAPIGatewayUrl;

        return Promise.resolve(
            that.fetchService.get(fetchUrl, this.constructor.name).then(response => {
                if (response && response[0] && response[0].status == 'SUCCESS') {
                    that.logger.debug('Retrieved advertisers:', response[0].Advertisers);
                    return response[0].Advertisers;
                }
            })
        );
    }

    getAdvertiser(advertiserKey) {
        let that = this;
        var advertiserName = this.browserStorage.getItem('advertiserName');
        this.logger.debug('getAdvertiserName() called:', advertiserKey, advertiserName);
        let fetchUrl = config.advertiserAPIGatewayUrl + '/' + advertiserKey;

        return Promise.all([
            that.fetchService.get(fetchUrl, that.constructor.name).then(response => {
                if (response && response.length > 0) {
                    var r = response[0];

                    if (r.status == 'SUCCESS') {
                        if (r.response.Advertiser) {
                            that.logger.debug('Advertiser: ', r.response);
                            var advertiserName = r.response.Advertiser.AdvertiserName;
                            this.browserStorage.setItem('advertiserName', advertiserName);

                            return {
                                status: 'SUCCESS',
                                advertiser: r.response.Advertiser
                            };
                        }
                    }

                    r.errors.unshift('Error retrieving advertiser');
                    return r;
                }
            })
        ]);
    }

    getAdvertiserName(advertiserKey) {
        let that = this;
        var key = this.browserStorage.getItem('advertiserKey');
        var advertiserName = this.browserStorage.getItem('advertiserName');
        this.logger.debug('getAdvertiserName() called:', advertiserKey, advertiserName);
        let fetchUrl = config.advertiserAPIGatewayUrl + '/' + advertiserKey;

        if (advertiserKey == key) {
            if (advertiserName && advertiserName.length > 0) {
                that.logger.debug('Advertiser: ', advertiserName);
                return Promise.resolve([
                    {
                        status: 'SUCCESS',
                        name: advertiserName
                    }
                ]);
            }
        } else {
            this.browserStorage.setItem('advertiserKey', advertiserKey);
        }

        return Promise.all([
            that.fetchService.get(fetchUrl, that.constructor.name).then(response => {
                if (response && response.length > 0) {
                    var r = response[0];

                    if (r.status == 'SUCCESS') {
                        if (r.response.Advertiser) {
                            that.logger.debug('Advertiser: ', r.response);
                            var advertiserName = r.response.Advertiser.AdvertiserName;
                            this.browserStorage.setItem('advertiserName', advertiserName);

                            return {
                                status: 'SUCCESS',
                                name: advertiserName
                            };
                        }
                    }

                    r.errors.unshift('Error retrieving advertiser');
                    return r;
                }
            })
        ]);
    }

    updateAdvertisers(patchData) {
        let url = config.advertiserAPIGatewayUrl;
        return this.patch(url, JSON.stringify(patchData));
    }

    get(url) {
        let that = this;
        let allHeaders = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };
        var authorize = this.browserStorage.getItem('authorization');

        if (authorize) {
            allHeaders.headers.Authorization = window.atob(authorize);
        }

        this.httpClient.configure(httpConfig => {
            httpConfig
                .withBaseUrl('/')
                .withDefaults({
                    headers: allHeaders.headers
                })
                .withInterceptor({
                    request(request) {
                        that.logger.debug(`Requesting ${request.method} ${request.url}`);
                        return request;
                    },
                    response(response) {
                        that.logger.debug(`Received ${response.status} ${response.url}`);
                        return response;
                    }
                });
        });

        return Promise.all([
            this.httpClient
                .fetch(url, {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include'
                })
                .then(response => response.json())
                .then(response => {
                    return response;
                })
        ]);
    }

    patch(url, patchData) {
        var that = this;

        return Promise.all([
            that.httpClient
                .fetch(url, {
                    method: 'PATCH',
                    body: patchData,
                    mode: 'cors',
                    credentials: 'include'
                })
                .then(response => response.json())
                .then(response => {
                    console.log(response);
                })
        ]);
    }
    put(url, payload) {
        var that = this;
        return Promise.all([
            that.httpClient
                .fetch(url, {
                    method: 'PUT',
                    body: payload,
                    mode: 'cors',
                    credentials: 'include'
                })
                .then(response => response.json())
                .then(response => {
                    console.log(response);
                    return response;
                })
        ]);
    }
}
